// extracted by mini-css-extract-plugin
export default {"ip_p":"LoginInput_ip_p__IzD4P","ip_label":"LoginInput_ip_label__ZNhfc","ip_input":"LoginInput_ip_input__MfQIv"};